import { render, staticRenderFns } from "./informacoesPessoais.vue?vue&type=template&id=355f60b9&scoped=true&"
import script from "./informacoesPessoais.vue?vue&type=script&lang=js&"
export * from "./informacoesPessoais.vue?vue&type=script&lang=js&"
import style0 from "./informacoesPessoais.vue?vue&type=style&index=0&id=355f60b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f60b9",
  null
  
)

export default component.exports